import { LoginButton } from '../LoginButton';

export const RightNav = () => {
  return (
    <div className="ml-auto flex items-center gap-5">
      <LoginButton />
    </div>
  );
};
